import React from 'react';
import { LanguageProvider } from './i18n';
import UDashboard from './udashboard';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <UDashboard />
    </LanguageProvider>
  );
}

export default App;
